import Vue from 'vue';

import { 大分類_販売管理費 } from '@/classes/common/Constants';

export default Vue.extend({
  name: 'C勘定科目中分類Select',

  props: {
    大分類: {
      type: String,
    },
    中分類: {
      type: String,
    },
  },

  computed: {
    opt中分類s(): string[] {
      switch (this.大分類) {
        case '流動資産':
          return ['現金及び預金', '売上債権', '棚卸資産', '有価証券', 'その他の流動資産'];
        case '固定資産':
          return ['有形固定資産', '無形固定資産', '投資その他の資産'];
        case '繰延資産':
          return [];
        case '流動負債':
          return ['仕入債務', 'その他の流動負債'];
        case '固定負債':
          return [];
        case '株主資本':
          return ['資本金', '新株式申込証拠金', '資本剰余金', '利益剰余金', '自己株式', '自己株式申込証拠金'];
        case '評価･換算差額等':
          return [];
        case '新株予約権':
          return [];
        case '売上高':
          return [];
        case '売上原価':
          return [
            '期首商品棚卸高',
            '当期商品仕入',
            '他勘定振替高（商）',
            '期末商品棚卸高',
            '期首製品棚卸高',
            '他勘定振替高（製）',
            '期末製品棚卸高',
          ];
        case 大分類_販売管理費:
          return [];
        case '営業外収益':
          return [];
        case '営業外費用':
          return [];
        case '特別利益':
          return [];
        case '特別損失':
          return [];
        case '法人税等':
          return [];
        case '材料費':
          return ['期首材料棚卸高', '当期材料費', '期末材料棚卸高'];
        case '労務費':
          return [];
        case '製造経費':
          return [];
        case '仕掛品':
          return ['期首仕掛品棚卸高', '他勘定振替高（仕）', '期末仕掛品棚卸高'];
        default:
          return [];
      }
    },
    selected: {
      get(): string {
        return this.中分類;
      },
      set(v: string): void {
        this.$emit('update:中分類', v);
      },
    },
  },

  watch: {
    大分類(): void {
      // 中分類が存在する場合はreturn
      if (this.opt中分類s.includes(this.中分類)) return;
      const 中分類 = this.opt中分類s.length > 0 ? this.opt中分類s[0] : null;
      this.$emit('update:中分類', 中分類);
    },
  },
});
